import { render } from "./CheckoutWhiteTestimonials.vue?vue&type=template&id=64bda848&scoped=true"
import script from "./CheckoutWhiteTestimonials.vue?vue&type=script&lang=js"
export * from "./CheckoutWhiteTestimonials.vue?vue&type=script&lang=js"

import "./CheckoutWhiteTestimonials.vue?vue&type=style&index=0&id=64bda848&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bda848"]])

export default __exports__